import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ErrorPage from "./Pages/ErrorPage/ErrorPage";
import SentInterest from "./Pages/SentInterest/SentInterest";
import FriendSentInterest from "./Pages/FriendSentInterest/FriendSentInterest";
import SentUnInterest from "./Pages/SentUnInterest/SentUnInterest";
import Preview from "./Pages/Preview/Preview";
import axios from "axios";

const baseUrl =
  document.getElementsByTagName("base")[0]?.getAttribute("href") ?? undefined;
const rootElement = document.getElementById("root");

fetch("/config.json").then((res) =>
  res
    .json()
    .then((config) => {
      axios.defaults.baseURL = config.apiBaseUrl;

      ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
          <Routes>
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/:campaignId" element={<App />} />
            <Route path="/thankyoucandidate" element={<SentInterest />} />
            <Route path="/thankyou" element={<FriendSentInterest />} />
            <Route path="/notinterested" element={<SentUnInterest />} />
            <Route path="/interested" element={<SentInterest />} />
            <Route
              path="/preview/:templateImage/:jobTitle/:description/:demands"
              element={<Preview />}
            />
          </Routes>
        </BrowserRouter>,
        rootElement
      );

      reportWebVitals();
    })
    .catch((error) => {
      console.log("Failed to load config.json", error);
    })
);
